import { Dialog, DialogContent, DialogTitle, Grid } from '@mui/material';
import FormActionButtons from 'components/ui/form/FormActionButtons';
import FormTextField from 'components/ui/form/FormTextField';
import { useFormik } from 'formik';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useNotification from 'hooks/useNotification';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

const validationSchema = yup.object({
  name: yup
    .string()
    .min(3, { label: 'settings.staff.validation.nameMin', value: 3 })
    .required('settings.staff.validation.name'),
});

const NameChangeModal = (props) => {
  const { open, setOpen, setRefetch, data } = props;
  const { t } = useTranslation();
  const axiosPrivate = useAxiosPrivate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const sendNotification = useNotification();

  const formik = useFormik({
    initialValues: {
      name: data?.name || '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        setIsSubmitting(true);
        const response = await axiosPrivate.post(
          '/admin/profile/updatename',
          JSON.stringify(values),
          { headers: { 'Content-Type': 'application/json' } }
        );
        if (response.data && response.data.status) {
          sendNotification({
            msg: response?.data?.message,
            variant: 'success',
          });
          setIsSubmitting(false);
          setRefetch(true);
          handleClose();
        }
      } catch (error) {
        sendNotification({
          msg: error?.response?.data?.message || error?.message,
          variant: 'error',
        });
        setIsSubmitting(false);
      }
    },
  });

  useEffect(() => {
    if (data?.name) {
      formik.setFieldValue('name', data?.name);
    }
  }, [data]);

  const handleClose = () => {
    formik.resetForm();
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='lg'
      disableEscapeKeyDown={true}
      PaperProps={{
        className: '!base-border !shadow-none',
      }}
    >
      <DialogTitle id='alert-dialog-title' className='bg-gray-100'>
        <span>{t('profile.changeName')}</span>
      </DialogTitle>

      <DialogContent className='!mt-4'>
        <form onSubmit={formik.handleSubmit}>
          <Grid
            container
            spacing={{ xs: 2, sm: 3, lg: 3 }}
            rowSpacing={1}
            columns={{ xs: 12, sm: 12, lg: 12 }}
          >
            <Grid item={true} lg={12} sm={12} xs={12}>
              <FormTextField
                delay={0.1}
                label={t('common.fields.name')}
                fieldName='name'
                formik={formik}
              />
            </Grid>

            <Grid item={true} sm={12} xs={12}>
              <div className='flex justify-end'>
                <FormActionButtons
                  delay={0.2}
                  isSubmitting={isSubmitting}
                  formType='dialog'
                  setOpen={setOpen}
                  reset={formik.resetForm}
                />
              </div>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default NameChangeModal;
